import Sortable from "@stimulus-components/sortable"
import { patch } from "@rails/request.js"

export class Controller extends Sortable {
  connect() {
    super.connect()
  }

  async onUpdate(event) {
    const newPosition = event.newIndex + 1

    await patch(
      event.item.dataset.sortableUpdateUrl,
      {
        body: JSON.stringify({
          new_position: newPosition
        })
      }
    )
  }
}
